const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authed/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});